<template>
    <dl class="flex flex-col text-sm leading-5 tracking-[0.25px]">
        <div
            v-for="row in rows"
            :key="row.label"
            class="odd:bg-bg even:bg-card flex h-12 items-center justify-between gap-4 px-4"
        >
            <dt class="font-normal">{{ row.label }}</dt>
            <dd class="font-black whitespace-nowrap">{{ row.value }}</dd>
        </div>
    </dl>
</template>

<script>
/** Striped label/value rows, as used in the "Other statistics" cards. Rows: [{ label, value }]. */
export default {
    name: 'StatsList',
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
}
</script>
